import { TrackEventProps } from "core/types";
import { initEncryptionCaches } from "./caches";
import decryptionLink from "./decryptionLink";
import encryptionLink from "./encryptionLink";
import trimDecryptedLink from "./trimDecryptedLink";

initEncryptionCaches();

const cryptoLinks = (trackingData: TrackEventProps) => [
  encryptionLink,
  decryptionLink,
  trimDecryptedLink(trackingData),
];

export default cryptoLinks;
